import axios from "axios";
import Cookies from "universal-cookie";

const cookies = new Cookies();

const instance = axios.create();

instance.defaults.headers.common['Access-Control-Allow-Credentials'] = true;
//  instance.defaults.baseURL = 'http://localhost:8000/api'
// instance.defaults.withCredentials = true;
// console.log(process.env.REACT_APP_BASE_URL)
instance.defaults.baseURL = process.env.REACT_APP_BASE_URL;

instance.interceptors.request.use(
    (config) => {
        const token = cookies.get('currentUser') ? cookies.get('currentUser')['token'] : cookies.get('adminUser')?.['token'];

        if (token && !config.headers?.['Authorization'])
            config.headers!["Authorization"] = 'Bearer ' + token;

        return config
    },
    
    (err) => {
        return Promise.reject(err);
    }
)

instance.interceptors.response.use(function(response) {
    return response;
},function(error){
    if(error.response.status === 401) {
        cookies.remove('currentUser', {path: '/'});
        window.location.replace('/login');
    }

    if (error.response.status === 403 && window.location.pathname !== '/wallet' && window.location.pathname !== '/payment')
        window.location.replace('/wallet');

    return Promise.reject(error);
});

export default instance;